import React from 'react'
import { useSelector } from 'react-redux'
import SideMenu from './SideMenu'

const styles = {
    container: {
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    logo: {
        height: 64,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        margin: '5px 16px 0 16px',
        backgroundPosition: 'center',
    },
    title: {
        color: '#000',
        fontSize: 14,
        textAlign: 'center',
        display: 'block',
        marginBottom: 20,
    },
}

function Side() {
    const building = useSelector((state) => state.app.building)
    const clientLogo = useSelector((state) => state.app.client.logo)
    const property = useSelector((state) => state.app.property)
    const roles = useSelector((state) => state.app.user.roles)

    const title = () => {
        if (roles.includes('PROPERTY_ADMIN')) {
            return property.name
        } else if (property.settings.multiBuilding) {
            return `${property.name}: ${building.name}`
        } else {
            return building.name
        }
    }

    const logoStyle = {
        ...styles.logo,
        backgroundImage: `url(${clientLogo})`,
    }

    return (
        <div style={styles.container}>
            <div style={logoStyle} />
            <span style={styles.title}>{title()}</span>
            <SideMenu />
        </div>
    )
}

export default Side
